module.exports = __webpack_public_path__ + "img/humbertomansilla.1e2b1a7a.jpg";